import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, type Rec } from './api';

/** Ключи вынесены сюда, чтобы инвалидация не разъезжалась по файлам. */
export const keys = {
  me: ['me'] as const,
  docs: ['docs'] as const,
  sections: ['sections'] as const,
  doc: (docId: string) => ['doc', docId] as const,
  tables: (docId: string) => ['tables', docId] as const,
  columns: (docId: string, tableId: string) => ['columns', docId, tableId] as const,
  records: (docId: string, tableId: string) => ['records', docId, tableId] as const,
  styles: (docId: string, tableId: string) => ['styles', docId, tableId] as const,
  history: (docId: string, tableId: string) => ['history', docId, tableId] as const,
  access: ['access'] as const,
  feedback: ['feedback'] as const,
};

export const useMe = () => useQuery({ queryKey: keys.me, queryFn: api.me, retry: false });

export const useDocs = () => useQuery({ queryKey: keys.docs, queryFn: api.docs });

export const useDoc = (docId: string) =>
  useQuery({ queryKey: keys.doc(docId), queryFn: () => api.docMeta(docId), enabled: !!docId });

export const useColumns = (docId: string, tableId: string) =>
  useQuery({
    queryKey: keys.columns(docId, tableId),
    queryFn: () => api.columns(docId, tableId),
    enabled: !!docId && !!tableId,
  });

export const useRecords = (docId: string, tableId: string) =>
  useQuery({
    queryKey: keys.records(docId, tableId),
    queryFn: () => api.records(docId, tableId),
    enabled: !!docId && !!tableId,
  });

// Мутации записей живут в useUndoableRecords: там же ведётся стек отмены,
// поэтому отдельные хуки на create/patch/delete здесь не нужны.
